module.exports = __webpack_public_path__ + "img/15.92d6530d.jpg";